import React from "react";
import ListItem from "@mui/material/ListItem";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import {BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {Link} from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import {BottomMenu, BackButton} from "./HookUtils";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import {BasketComponent} from "./BasketComponent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

// سئو
import {Helmet} from "react-helmet-async";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/* ---------- Market summary card (top) ---------- */
function MarketSummaryCard({market, productCount, categoryTitle , table_id}) {
    if (!market) return null;

    const logo = market.logo
        ? PRODUCT_BASE_URL_API + market.logo
        : "/hamekara-logo.png";

    const marketId = market.id ?? market.market_id;
    const marketLink = marketId ? `/market?id=${marketId}` : "#";

    const handleCopyInfo = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const text = `${market.name ?? ""} - ${market.tell ?? ""} - ${
            market.address ?? ""
        }`;
        navigator.clipboard.writeText(text);
    };

    const handleWhatsApp = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!market.whatsapp || market.whatsapp === "none") return;
        window.open(`https://wa.me/${market.whatsapp}`, "_blank");
    };

    return (
        <Paper
            elevation={0}
            sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                border: "1px solid rgba(0,0,0,0.06)",
                bgcolor: "#fff",
                direction: "rtl",
                display: "flex",
                alignItems: "flex-start",
                gap: 1.5,
            }}
        >
            <Avatar
                src={logo}
                alt={market.name}
                sx={{
                    width: 56,
                    height: 56,
                    border: "2px solid #fff",
                    boxShadow: 1,
                    bgcolor: "#fff",
                    flexShrink: 0,
                }}
            />

            <Box sx={{minWidth: 0, flex: 1}}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{fontWeight: 800}}
                        noWrap
                        title={market.name}
                    >
                        {market.name}
                    </Typography>

                </Box>


                {market.address && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "text.secondary",
                            mb: 0.5,
                        }}
                    >
                        <Chip
                            icon={<StorefrontOutlinedIcon/>}
                            label="فروشگاه متصل به همه‌کارا"
                            size="small"
                            sx={{
                                bgcolor: "grey.100",
                                "& .MuiChip-icon": {fontSize: 16},
                            }}
                        />
                        <RoomOutlinedIcon fontSize="small"/>
                        <Typography
                            variant="caption"
                            noWrap
                            title={market.address}
                        >
                            {market.address}
                        </Typography>
                    </Box>
                )}

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        mt: 1,
                    }}
                >
                    <Chip
                        size="small"
                        icon={<CategoryOutlinedIcon/>}
                        label={`${productCount} کالا در دسته «${categoryTitle}»`}
                        sx={{
                            bgcolor: "grey.100",
                            "& .MuiChip-icon": {fontSize: 18},
                        }}
                    />

                    {!table_id && (
                        <>
                            {market.whatsapp && market.whatsapp !== "none" && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    startIcon={<WhatsAppIcon />}
                                    onClick={handleWhatsApp}
                                    sx={{
                                        borderRadius: "999px",
                                        borderColor: "#25D366",
                                        color: "#25D366",
                                        "&:hover": {
                                            borderColor: "#1DA851",
                                            backgroundColor: "rgba(37,211,102,0.08)",
                                        },
                                        fontWeight: 600,
                                    }}
                                >
                                    گفت‌وگو در واتساپ
                                </Button>
                            )}

                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ContentCopyIcon />}
                                onClick={handleCopyInfo}
                                sx={{
                                    borderRadius: "999px",
                                    borderColor: "#2196f3",
                                    color: "#2196f3",
                                    "&:hover": {
                                        borderColor: "#1976d2",
                                        backgroundColor: "rgba(33,150,243,0.08)",
                                    },
                                    fontWeight: 600,
                                }}
                            >
                                کپی اطلاعات فروشگاه
                            </Button>

                            {marketId && (
                                <Button
                                    component={Link}
                                    to={marketLink}
                                    variant="contained"
                                    size="small"
                                    sx={{
                                        borderRadius: "999px",
                                        fontWeight: 700,
                                        bgcolor: "#ff1744",
                                        "&:hover": { bgcolor: "#e0143d" },
                                        ml: "auto",
                                    }}
                                >
                                    ورود به فروشگاه
                                </Button>
                            )}
                        </>
                    )}


                </Box>
            </Box>
        </Paper>
    );
}

export class AllProductComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            productList: [],
            marketInfo: null,
        };
    }

    componentDidMount() {
        const {market_id, child_category_id , table_id} = this.props;

        // 1) محصولات
        fetch(
            BASE_URL_API +
            "product?market_id=" +
            market_id +
            "&child_category_id=" +
            child_category_id +
            "&table_id="+table_id,            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("pwa_token"),
                    "Content-Type": "application/json",
                },
            }
        )
            .then((response) => response.json())
            .then(
                (results) => {
                    // Sort products: those with pictures first
                    const sortedProducts = results.data.sort((a, b) => {
                        return (
                            (b.pictures.length > 0 ? 1 : 0) -
                            (a.pictures.length > 0 ? 1 : 0)
                        );
                    });
                    this.setState({productList: sortedProducts});
                },
                (error) => {
                    console.log("product error", error);
                }
            );

        // 2) اطلاعات مارکت (طبق الگوی خودت)
        if (market_id) {
            fetch(BASE_URL_API + "market/" + market_id, {
                headers: {
                    Authorization:
                        "Bearer " + localStorage.getItem("pwa_token"),
                    "Content-Type": "application/json",
                },
            })
                .then((response) => response.json())
                .then((results) => {
                    if (results.code === 200) {
                        this.setState({marketInfo: results.data});
                    }
                })
                .catch((error) => console.log("market error", error));
        }
    }

    renderProductCard = (product,table_id) => {
        const MAX_LENGTH = 20;

        const hasVariants =
            Array.isArray(product.variants) &&
            product.variants.length > 0;

        const formatStep = (val) => {
            const num = Number(val);
            if (!isFinite(num) || num <= 0) return "";
            return parseFloat(num.toFixed(4)).toLocaleString("en", {
                maximumFractionDigits: 4,
            });
        };

        const formatTomans = (val) =>
            Number(val || 0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان ";

        const formatNumber = (val) =>
            Number(val || 0)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // -------- TOTAL STOCK --------
        const totalStock = hasVariants
            ? product.variants.reduce(
                (sum, v) => sum + Number(v.step || 0),
                0
            )
            : Number(product.step || 0);

        // -------- VARIANT PRICE RANGE --------
        let variantPriceBlock = null;

        if (hasVariants) {
            const variantData = product.variants
                .map(v => {
                    const base = Number(v.customer_price || 0);
                    if (base <= 0) return null;
                    return base;
                })
                .filter(Boolean);

            if (variantData.length > 0) {
                const min = Math.min(...variantData);
                const max = Math.max(...variantData);

                variantPriceBlock = (
                    <Box sx={{ mt: "auto" }}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "success.main",
                                fontWeight: 700,
                                whiteSpace: "nowrap",
                                direction: "rtl",
                            }}
                        >
                            <strong>
                                {min === max
                                    ? formatTomans(min)
                                    : `${formatNumber(min)} تا ${formatTomans(max)}`}
                            </strong>
                        </Typography>
                    </Box>
                );
            }
        }

        return (
            <ListItem
                key={product.id}
                component={Link}
                to={"/product?id=" + product.id + `&table_id=${table_id}`}
                sx={{
                    width: 150,
                    px: 0,
                    textDecoration: "none",
                    color: "inherit",
                }}
            >
                <Paper
                    elevation={1}
                    sx={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 2,
                        p: 1.25,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        transition:
                            "transform 120ms ease, box-shadow 120ms ease",
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: 3,
                        },
                    }}
                >
                    {/* IMAGE */}
                    <Box
                        sx={{
                            width: 140,
                            height: 140,
                            borderRadius: 1.5,
                            overflow: "hidden",
                            bgcolor: "#ffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Box
                            component="img"
                            alt={product.title}
                            src={
                                product.pictures?.length > 0
                                    ? PRODUCT_BASE_URL_API +
                                    product.pictures[0].url
                                    : "hamekara-logo.png"
                            }
                            sx={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                display: "block",
                            }}
                        />
                    </Box>

                    {/* TITLE */}
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 700,
                            color: "text.primary",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            direction: "rtl",
                        }}
                        title={product.title}
                    >
                        {product.title.length > MAX_LENGTH
                            ? `${product.title.substring(0, MAX_LENGTH)}...`
                            : product.title}
                    </Typography>

                    {/* VARIANT PILLS */}
                    {hasVariants && (
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 0.5,
                                direction: "rtl",
                            }}
                        >
                            {product.variants.slice(0, 4).map((variant, index) => {
                                const label = (variant.attribute_values || [])
                                    .map(av => av?.value)
                                    .filter(Boolean)
                                    .join(" - ");

                                if (!label) return null;

                                return (
                                    <Chip
                                        key={index}
                                        label={label}
                                        size="small"
                                        sx={{
                                            fontSize: 10,
                                            height: 20,
                                            borderRadius: "12px",
                                            bgcolor: "#f5f5f5",
                                            color: "#555",
                                            px: 0.8,
                                        }}
                                    />
                                );
                            })}
                        </Box>
                    )}

                    {/* INVENTORY */}
                    <Typography
                        variant="caption"
                        sx={{
                            lineHeight: 1.2,
                            color:
                                totalStock > 0
                                    ? "text.secondary"
                                    : "error.main",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            whiteSpace: "nowrap",
                            direction: "rtl",
                        }}
                    >
                        {totalStock > 0 ? (
                            <>
                                <Inventory2Icon fontSize="inherit" />
                                موجودی:&nbsp;{formatStep(totalStock)}
                            </>
                        ) : (
                            "تماس بگیرید"
                        )}
                    </Typography>

                    {product.markets?.name && (
                        <Chip
                            label={product.markets.name}
                            size="small"
                            sx={{
                                display: "inline-flex",
                                width: "fit-content",
                                direction: "rtl",
                                fontSize: 11,
                                height: 22,
                                borderRadius: 1,
                                px: 0.8,
                                bgcolor: "grey.100",
                                color: "text.secondary",
                            }}
                            title={product.markets.name}
                        />
                    )}

                    {/* PRICE */}
                    {hasVariants
                        ? variantPriceBlock
                        : Number(product.del_price) > 0 ? (
                            <Box sx={{ mt: "auto" }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "text.secondary",
                                        textDecoration: "line-through",
                                        whiteSpace: "nowrap",
                                        direction: "rtl",
                                    }}
                                >
                                    <strong>{formatTomans(product.price)}</strong>
                                </Typography>

                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "success.main",
                                        fontWeight: 700,
                                        whiteSpace: "nowrap",
                                        direction: "rtl",
                                    }}
                                >
                                    <strong>
                                        {formatTomans(
                                            parseInt(product.price, 10) -
                                            parseInt(product.del_price, 10)
                                        )}
                                    </strong>
                                </Typography>
                            </Box>
                        ) : (
                            <Box sx={{ mt: "auto" }}>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color:
                                            Number(product.price) > 0
                                                ? "success.main"
                                                : "warning.main",
                                        fontWeight: 700,
                                        whiteSpace: "nowrap",
                                        direction: "rtl",
                                    }}
                                >
                                    <strong>
                                        {Number(product.price) > 0
                                            ? formatTomans(product.price)
                                            : "تماس بگیرید."}
                                    </strong>
                                </Typography>
                            </Box>
                        )}
                </Paper>
            </ListItem>
        );
    };

    render() {
        const {productList, marketInfo} = this.state;
        const {table_id} = this.props;

        const firstProduct = productList[0];
        const categoryTitle =
            firstProduct?.category?.title || "محصولات فروشگاه";
        const marketName = marketInfo?.name || "";

        // SEO
        const seoTitle = marketName
            ? `${categoryTitle} در ${marketName} | همه‌کارا`
            : `${categoryTitle} | همه‌کارا`;

        const seoDescription = marketName
            ? `مشاهده و خرید آنلاین ${categoryTitle} از فروشگاه ${marketName} در سامانه همه‌کارا.`
            : `لیست محصولات ${categoryTitle} در سامانه فروشگاهی همه‌کارا.`;

        const canonicalUrl =
            typeof window !== "undefined"
                ? window.location.href.split("#")[0]
                : "";

        return (
            <div>
                {/* Helmet برای canonical و عنوان / توضیحات */}
                <Helmet>
                    {canonicalUrl && (
                        <link rel="canonical" href={canonicalUrl}/>
                    )}
                    <title>{seoTitle}</title>
                    <meta name="description" content={seoDescription}/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:title" content={seoTitle}/>
                    <meta
                        property="og:description"
                        content={seoDescription}
                    />
                </Helmet>

                <AppBar
                    style={{
                        background: "rgba(238,238,238,0.3)",
                        overflow: "auto",
                        display: "flex",
                    }}
                >
                    <ToolbarMui>
                        <CategoryOutlinedIcon style={{color: "black"}}/>

                        {productList.length > 0 ? (
                            <ListItemText
                                align="center"
                                primary={
                                    <Typography
                                        variant="subtitle2"
                                        component="div"
                                        sx={{
                                            mx: 1,
                                            flex: "1 1 auto",
                                            textAlign: "center",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            fontWeight: 900,
                                            fontSize: "1rem",
                                            letterSpacing: "0.3px",
                                            color: "#fff",
                                            textShadow: `
                                  0 0 4px rgba(255, 255, 255, 0.7),
                                  0 0 8px rgba(255, 100, 100, 0.5),
                                  0 0 12px rgba(255, 17, 17, 0.45)
                                `,
                                            background:
                                                "linear-gradient(90deg, #ff1744, #ff5252, #fff)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                            animation:
                                                "shineMove 2s linear infinite",
                                            "@keyframes shineMove": {
                                                "0%": {
                                                    backgroundPosition: "0% 50%",
                                                },
                                                "100%": {
                                                    backgroundPosition:
                                                        "200% 50%",
                                                },
                                            },
                                            backgroundSize: "200% auto",
                                        }}
                                        title={categoryTitle}

                                    >
                                        {categoryTitle}
                                    </Typography>
                                }
                            />
                        ) : (
                            ""
                        )}

                        {/* 🔍 تغییر لینک سرچ طبق خواسته‌ی تو */}
                        <IconButton
                            component={Link}
                            to={`/search?prefer_market_id=${
                                marketInfo ? marketInfo.id : ""
                            }&table_id=${table_id}`}
                            style={{color: "black"}}
                            size="large"
                        >
                            <SearchIcon/>
                        </IconButton>

                        <IconButton style={{color: "black"}} size="large">
                            <BasketComponent/>
                        </IconButton>

                        <IconButton
                            onClick={() =>window.close()}
                            style={{ color: 'black'  }}
                        ><ArrowBackIcon/></IconButton>
                    </ToolbarMui>
                </AppBar>

                <React.Fragment>
                    <Box
                        sx={{
                            mt: 10,
                            mb: 10,
                            px: 1.5,
                        }}
                    >
                        {/* Market info card */}
                        {marketInfo && (
                            <MarketSummaryCard
                                market={marketInfo}
                                productCount={productList.length}
                                categoryTitle={categoryTitle}
                                table_id={table_id}
                            />
                        )}

                        {/* Category header / stats */}
                        <Box
                            sx={{
                                direction: "rtl",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                mb: 1.5,
                            }}
                        >
                            <Box sx={{minWidth: 0, flex: 1}}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 800,
                                        mb: 0.25,
                                    }}
                                >
                                    همه محصولات «{categoryTitle}»
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{color: "text.secondary"}}
                                >
                                    {productList.length} کالا در این دسته
                                </Typography>
                            </Box>


                        </Box>

                        <Divider sx={{mb: 2}}/>

                        {/* Product grid */}
                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                gap: 1.5,
                            }}
                        >
                            {productList.map((product) =>
                                this.renderProductCard(product , table_id)
                            )}
                        </Box>
                    </Box>


                    {!table_id && <BottomMenu/>}
                </React.Fragment>
            </div>
        );
    }
}
